export class UpdateLocaleEvent {
  private _locale: string;

  constructor(locale: string) {
    this._locale = locale;
  }

  get locale(): string {
    return this._locale;
  }
}
